import { useSearchParams } from 'react-router';
import { ViewModeParamName } from '../constants';

export function useViewMode() {
  const search = useSearchParams()[0];

  return search.get(ViewModeParamName) === 'true';
}
